// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';


import { fuelCardApi, routeApi, tripApi } from '../lib/api';

import { tripStatusEnum, waypointTypeEnum } from '../lib/enum';
import { withCompensation } from '../lib/routeEntityCompensation';

export const FETCH_TRIP = 'vehicles/trip/fetch';
export const CLEAN_TRIP = 'vehicles/trip/clean';



const initialState: any = null;

const fetchTripAction = createAction<any>(FETCH_TRIP);
const cleanTripAction = createAction(CLEAN_TRIP);

const tripSlice = createSlice({
  name: 'trip',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(fetchTripAction, (state, { payload }) => ({ ...payload })).
    addCase(cleanTripAction, () => null);
  }
});

export const tripActions = {
  fetch: fetchTripAction,
  clean: cleanTripAction
};

export const addTrip =
(trip) =>
async (dispatch, getState) => {
  const addedRoute = await routeApi.addRoute(trip.expectedRoute);
  const saved = await withCompensation(
    () => tripApi.addTrip({
      ...trip,
      expectedRouteId: addedRoute.id
    }),
    () => routeApi.deleteRoute(addedRoute.id)
  );

  if (getState().trip !== null) {
    dispatch(tripActions.fetch({ ...saved }));
  }
  return saved;
};

export const updateTrip =
(trip) =>
async (dispatch, getState) => {
  let previousExpectedRoute;
  if (trip.expectedRoute) {
    previousExpectedRoute = await routeApi.fetchRoute(
      trip.expectedRoute.id || trip.expectedRouteId
    );
    await routeApi.updateRoute(trip.expectedRoute);
  }
  if (trip.actualRoute) {
    const startWaypoint = trip.actualRoute.waypoints.find(
      (waypoint) => waypoint.type === waypointTypeEnum.start
    );
    let endWaypoint;
    if (trip.actualRoute) {
      endWaypoint = trip.actualRoute.waypoints.find(
        (waypoint) => waypoint.type === waypointTypeEnum.end
      );
    }
    if (startWaypoint && startWaypoint.departureDateTime) {
      trip.startDate = startWaypoint.departureDateTime;
    }
    if (endWaypoint && endWaypoint.arrivedDateTime) {
      trip.endDate = endWaypoint.arrivedDateTime;
    }
  } else if (trip.expectedRoute) {
    const startWaypoint = trip.expectedRoute.waypoints.find(
      (waypoint) => waypoint.type === waypointTypeEnum.start
    );
    const endWaypoint = trip.expectedRoute.waypoints.find(
      (waypoint) => waypoint.type === waypointTypeEnum.end
    );
    if (startWaypoint && startWaypoint.departureDateTime) {
      trip.startDate = startWaypoint.departureDateTime;
    }
    if (endWaypoint && endWaypoint.arrivedDateTime) {
      trip.endDate = endWaypoint.arrivedDateTime;
    }
  }
  const updated = previousExpectedRoute ?
  await withCompensation(
    () => tripApi.updateTrip(trip),
    () => routeApi.updateRoute(previousExpectedRoute)
  ) :
  await tripApi.updateTrip(trip);
  if (trip.expectedRouteId) {
    // Тянем все наши роуты
    updated.expectedRoute = await routeApi.fetchRoute(trip.expectedRouteId);
  }
  const actualRouteId = parseInt(updated.actualRouteId);
  if (actualRouteId) {
    updated.actualRoute = await routeApi.fetchRoute(actualRouteId);
  }

  // Обновляем стейт, если только в нем что-то есть,
  // т.к. обновление ПЛ (путевого листа) может происходит
  // не только в форме и карточке ПЛ
  if (getState().trip !== null) {
    dispatch(tripActions.fetch({ ...updated }));
  }
  return updated;
};

export const verifyTrip =
(trip) => async (dispatch, getState) => {
  let previousActualRoute;
  if (trip.actualRoute) {
    previousActualRoute = await routeApi.fetchRoute(trip.actualRoute.id);
    await routeApi.updateRoute(trip.actualRoute);
  }
  if (previousActualRoute) {
    await withCompensation(
      () => tripApi.updateTrip(trip),
      () => routeApi.updateRoute(previousActualRoute)
    );
  } else {
    await tripApi.updateTrip(trip);
  }
};

export const fetchTrip =
(id) =>
async (dispatch) => {
  const trip = await tripApi.fetchTrip(id);
  // Тянем все наши роуты
  if (trip.expectedRouteId) {
    trip.expectedRoute = await routeApi.fetchRoute(trip.expectedRouteId);
  }
  const actualRouteId = parseInt(trip.actualRouteId);
  if (actualRouteId) {
    trip.actualRoute = await routeApi.fetchRoute(actualRouteId);
  }
  // тянем топливную карту
  if (trip.vehicle) {
    trip.vehicle.fuelCard = (
    await fuelCardApi.fetchVehicleFuelCards(trip.vehicle.id))[
    0];
  }
  dispatch(tripActions.fetch(trip));
  return trip;
};

export const fetchTripForVerification =
(id, onDisableVerifyFn) =>
async (dispatch) => {
  const trip = await tripApi.fetchTrip(id);
  if (
  trip.status !== tripStatusEnum.opened &&
  trip.status !== tripStatusEnum.verification)
  {
    if (typeof onDisableVerifyFn === 'function') {
      onDisableVerifyFn();
    }
    return trip;
  }
  if (trip.status !== tripStatusEnum.verification) {
    await tripApi.changeStatus({
      id: trip.id,
      status: tripStatusEnum.verification
    });
  }
  // Тянем все наши роуты
  trip.expectedRoute = await routeApi.fetchRoute(trip.expectedRouteId);

  if (trip.actualRouteId) {
    trip.actualRoute = await routeApi.fetchRoute(trip.actualRouteId);
  } else {
    // Клонируем роут для таксировки, если он еще не назначен
    trip.actualRoute = await routeApi.cloneRoute(trip.expectedRouteId);
    trip.actualRouteId = trip.actualRoute.id;
    const clonedRoute = trip.actualRoute;
    await withCompensation(
      () => tripApi.updateTrip(trip),
      () => routeApi.deleteRoute(clonedRoute.id)
    );
  }

  dispatch(tripActions.fetch(trip));
  return trip;
};

export const cleanTrip =
() =>
(dispatch) =>
dispatch(tripActions.clean());

export const changeStatus =
(id, status) =>
async (dispatch) => {
  const trip = await tripApi.changeStatus({ id, status });
  return await dispatch(fetchTrip(trip.id));
};

export default tripSlice.reducer;
